export default {
  getBabyDrum: state =>  {
    return state.babyDrum
  }
}